.fp-separator.-secondary
